export default {
  BLUR: 'blur',
  CANCEL: 'cancel',
  CHANGE: 'change',
  CLOSE: 'close',
  SUBMIT: 'submit',
  OPEN: 'open'
};
